'use client';

import { domain_url } from '@/constants/apiConstant';
import { useGlobalContext } from '@/context/GlobalContext';
import HomeLayouts from '@/layouts/HomeLayouts';
import { filterIsAbroadCountry } from '@/utils/formatItems';
import {
  generateArticleSchema,
  generateExamBreadcrumbSchema,
  generateFAQSchema,
  generateWebPageSchema,
} from '@/utils/seo/schema';

import PageNavbar from '@/components/colleges/CollegeNavbar';
import PageDetailsTab from '@/components/common/pageData/PageTabDetail';
import HeroSection from '@/components/exams/ExamHeroSection';

const ExamPageComponent = ({ examData, examId, tab, seoData, pageData }: any) => {
  const { setIsLeadFormOpen, setLeadFormData } = useGlobalContext();
  const pathValue = (tab?.replace(/\s+/g, '-')?.toLowerCase() as string) || 'overview';
  const navbar = examData?.exam_navbars;
  const isAbroadExam = filterIsAbroadCountry(examData);
  const exam_url = `${domain_url}/exams/${examData?.exam_url}/${tab}`;
  const exam_title = seoData?.[0]?.main_title ?? examData?.exam_title;

  const handleOpen = (examId: any, examName: any) => {
    setLeadFormData({
      source: `examPage`,
      exam: examId || null,
      title: examName || null,
      isAbroadCountry: isAbroadExam ?? false,
    });
    setIsLeadFormOpen(true);
    console.log('exam', examId);
  };

  const faqData = pageData?.find((data: any) => data?.__component?.trim() === 'common.faq');
  const title = examData?.abbreviation ?? examData?.exam_name;
  const author_name = examData?.data?.updated_by_user?.name || examData?.created_by_user?.name;
  const webPageSchema = generateWebPageSchema(title, exam_url);
  const faqSchema = generateFAQSchema(faqData);
  const breadcrumbItems = generateExamBreadcrumbSchema(examData, isAbroadExam, domain_url, exam_url);

  const articleSchema = generateArticleSchema(
    title,
    domain_url,
    exam_url,
    author_name,
    examData?.updatedAt,
    examData?.publishedAt,
    examData?.logo?.url,
  );

  return (
    <>
      
        {domain_url === 'https://collegehai.com' && examData?.exam_url && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(webPageSchema),
            }}
          />
        )}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              speakable: {
                '@type': 'SpeakableSpecification',
                xpath: ['/html/head/title', '/html/body//h1', '/html/body//p[1]'],
              },
              url: exam_url,
            }),
          }}
        />
        {breadcrumbItems.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: breadcrumbItems,
              }),
            }}
          />
        )}

        {faqSchema && (
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
        )}
        {articleSchema && (
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
        )}
      
      <HomeLayouts>
        <HeroSection
          examData={examData}
          handleOpen={handleOpen}
          breadcrumbItems={breadcrumbItems}
          exam_title={exam_title}
        />
        <div className="flex flex-col px-2 py-4 md:hidden">
          <div className="flex items-center gap-2">
            <div>Exam Mode :</div>
            <div className="flex items-center gap-2">
              <div className="w-fit rounded-lg bg-orange-300 px-2 text-sm ">{examData?.exam_mode?.exam_mode}</div>
            </div>
          </div>
          <div className="flex w-full justify-between gap-x-4 px-2 pb-2 pt-4">
            <div className="w-full ">
              <button
                className=" w-full rounded-md bg-secondary py-1.5 text-white duration-300"
                onClick={() => handleOpen(examData?.id, examData?.abbreviation)}
              >
                {' '}
                {'Register Now'}
              </button>
            </div>
          </div>
        </div>

        {/* Exam navbar */}

        <PageNavbar entity="exams" navbar={navbar} url={examId} pathValue={pathValue} />

        {/* Page Data content */}
        <section className="mx-auto w-full lg:max-w-[73.75rem] 2xl:max-w-screen-xl">
          <PageDetailsTab tabsData={pageData} page={examData} currentTab={pathValue} />
        </section>
      </HomeLayouts>
    </>
  );
};

export default ExamPageComponent;
